import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import { LinkButton } from '../../index';
import styles from './styles';

const useStyles = makeStyles(styles);

interface OwnProps {
  links?: LinkButton[];
}

const LoginDownBar: React.FC<OwnProps> = ({ links }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Hidden mdDown>
        <Grid container item xs={8} spacing={2}>
          {links &&
            links.length > 0 &&
            links.map(item => (
              <Grid key={`down-bar-link-${item.name}`} item>
                {item.external ? (
                  <a
                    href={item.url}
                    className={classes.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                ) : (
                  <Typography
                    component={Link}
                    to={item.url}
                    variant="body1"
                    className={classes.link}
                  >
                    {item.name}
                  </Typography>
                )}
              </Grid>
            ))}
        </Grid>
      </Hidden>
      <Grid
        container
        item
        xs={12}
        lg={4}
        justify={window.innerWidth > 1200 ? 'flex-end' : 'center'}
      >
        <Typography variant="body1">
          <img
            className={classes.logo}
            src="/images/skyoneNewLogo.png"
            alt="Logo Sky.One"
          />
        </Typography>
      </Grid>
    </React.Fragment>
  );
};

export default LoginDownBar;
